/** Per-kind bond wizard page config with lazy loading to avoid cross-kind import chains in tests. */
export const bondWizardPageConfig = {
  get guardianship() {
    return require("./bondWizardPageConfigs/guardianship").default;
  },
  get va() {
    return require("./bondWizardPageConfigs/va").default;
  },
  get trustee() {
    return require("./bondWizardPageConfigs/trustee").default;
  },
  get probate() {
    return require("./bondWizardPageConfigs/probate").default;
  },
  get blanket() {
    return require("./bondWizardPageConfigs/blanket").default;
  },
};
